import { FileType } from 'features/content-library/types';

type Permissions = {
  canPresentLibrary: boolean;
  canEditWhiteboard: boolean;
};

export const canOpenContentLibraryItem = (
  type: FileType | null,
  { canPresentLibrary, canEditWhiteboard }: Permissions
) => (type === 'whiteboard' ? canEditWhiteboard : canPresentLibrary);
